import authEn from "@/locales/auth.en.json";
import calendarEn from "@/locales/calendar.en.json";
import clientsEn from "@/locales/clients.en.json";
import coreEn from "@/locales/core.en.json";
import homeEn from "@/locales/home.en.json";
import leadsEn from "@/locales/leads.en.json";
import pipelineEn from "@/locales/pipeline.en.json";
import reportsEn from "@/locales/reports.en.json";
import requestsEn from "@/locales/requests.en.json";
import targetsEn from "@/locales/targets.en.json";
import teamEn from "@/locales/team.en.json";
import unitsEn from "@/locales/units.en.json";

/* One catalog per area so features grow without stepping on each other. Ids are unique across
   catalogs. The interface ships in English; Arabic is a matter of adding `*.ar.json` catalogs
   and a second Locale, because every string already goes through useT. */
const en = {
  ...coreEn,
  ...authEn,
  ...homeEn,
  ...unitsEn,
  ...clientsEn,
  ...leadsEn,
  ...pipelineEn,
  ...requestsEn,
  ...calendarEn,
  ...teamEn,
  ...targetsEn,
  ...reportsEn,
};

export type Locale = "en";
export type MessageId = keyof typeof en;

export const DEFAULT_LOCALE: Locale = "en";

export const MESSAGES: Record<Locale, Record<MessageId, string>> = { en };

export function isMessageId(value: string): value is MessageId {
  return Object.hasOwn(en, value);
}

const DIRECTIONS: Record<Locale, "ltr" | "rtl"> = { en: "ltr" };
const INTL_LOCALES: Record<Locale, string> = { en: "en-GB" };

export function directionOf(locale: Locale): "ltr" | "rtl" {
  return DIRECTIONS[locale];
}

/** The Intl locale behind each interface language: day-month-year, as dates are read in Egypt. */
export function intlLocaleOf(locale: Locale): string {
  return INTL_LOCALES[locale];
}
